"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doesPreferReducedMotion = exports.jsonStringifyFunctions = exports.execPromiseCallbackStrict = exports.execPromiseCallback = exports.dontBubble = exports.execCallback = exports.timeToPass = exports.getRandomBetween = void 0;
exports.isLocalhost = isLocalhost;
const is_promise_1 = __importDefault(require("is-promise"));
const lodash_isfunction_1 = __importDefault(require("lodash.isfunction"));
const global_utils_content_1 = __importDefault(require("./global-utils.content"));
/**
 * Generate a random, whole, number between specified min and max values.
 * Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random
 */
const getRandomBetween = (min, max) => Math.round(Math.random() * (max - min) + min);
exports.getRandomBetween = getRandomBetween;
/**
 * Promise-wrapped `setTimeout()`.
 */
const timeToPass = ms => __awaiter(void 0, void 0, void 0, function* () {
  return new Promise(resolve => setTimeout(resolve, ms));
});
exports.timeToPass = timeToPass;
/**
 * Safely execute a callback.
 */
const execCallback = function (cb) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key2 = 1; _key2 < _len; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  // eslint-disable-next-line node/no-callback-literal
  if ((0, lodash_isfunction_1.default)(cb)) return cb(...args);
};
exports.execCallback = execCallback;
/**
 * Exec a callback on click, but don't allow the click event to
 * bubble/propagate upwards and trigger any other events.
 *
 * For use in click event handlers.
 */
const dontBubble = cb => e => {
  e.stopPropagation();
  (0, exports.execCallback)(cb);
};
exports.dontBubble = dontBubble;
/**
 * Execute a promise with a fallback promise, should it not exist.
 */
const execPromiseCallback = function (promise) {
  let fallbackPromise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Promise.resolve();
  for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key3 = 2; _key3 < _len2; _key3++) {
    rest[_key3 - 2] = arguments[_key3];
  }
  const cb = (0, exports.execCallback)(promise, ...rest);
  return (0, is_promise_1.default)(cb) ? cb : fallbackPromise;
};
exports.execPromiseCallback = execPromiseCallback;
/**
 * If promise doesn't exist, throw catch-able error.
 */
const execPromiseCallbackStrict = function (promise) {
  for (var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key4 = 1; _key4 < _len3; _key4++) {
    rest[_key4 - 1] = arguments[_key4];
  }
  return (0, exports.execPromiseCallback)(promise, Promise.reject(global_utils_content_1.default.PROMISE_DOESNT_EXIST), ...rest);
};
exports.execPromiseCallbackStrict = execPromiseCallbackStrict;
/**
 * `JSON.stringify` but it returns functions as empty object,
 *  instead of omitting them from the returned value.
 */
const jsonStringifyFunctions = object => JSON.stringify(object, (_key, value) => typeof value === "function" ? {} : value);
exports.jsonStringifyFunctions = jsonStringifyFunctions;
/**
 * Returns whether provided URL string is `localhost`
 */
function isLocalhost(url) {
  const localhostRegex = /^https?:\/\/localhost(:\d{4})?/;
  return localhostRegex.test(url);
}
/**
 * Returns the system preference for reduced motion.
 */
const doesPreferReducedMotion = () => {
  var _a;
  return typeof window !== "undefined" && ((_a = window === null || window === void 0 ? void 0 : window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-reduced-motion: reduce)").matches);
};
exports.doesPreferReducedMotion = doesPreferReducedMotion;